/**
 * HP-internal orderType keys — used for getAccessToken and getPaymentHash.
 * Add a new entry here whenever a new payment flow is introduced.
 */
export const PAYMENT_ORDER_TYPES = {
  SELLER_ONBOARDING: 'seller_onboarding',
};

const SELLER_DEV_HOST = 'sellerdev.hyperpure.com';
const getCurrentHostName = () => (typeof window === 'undefined' ? '' : window.location.hostname);
const isSellerTestingWebsite = () => {
  const hostName = getCurrentHostName();
  return hostName === SELLER_DEV_HOST || hostName === 'localhost';
};

/**
 * HP orderType → ZPayKit service_type.
 * orderType goes to HP backend APIs; service_type goes to the ZPayKit SDK.
 */
export const ORDER_TYPE_TO_SERVICE_TYPE = {
  [PAYMENT_ORDER_TYPES.SELLER_ONBOARDING]: isSellerTestingWebsite() ? 'HP_SELLER_ONBOARDING' : 'HP_SELLER_ONBOARDING',
};
